import { ref } from 'vue'
const subscribers = ref(new Set());
export function useHeaderEvents() {
    const emit = (eventData) => {
        subscribers.value.forEach(callback => callback(eventData))
    }
    const listen = (callback) => {
        subscribers.value.add(callback);

        //Return unsubscribe function
        return () => {
            subscribers.value.delete(callback);
        }
    }

    return { emit, listen }
}